@if (multiSelect.isSelecting()) {
  <div
    class="bar mat-elevation-z4"
    role="toolbar"
    [attr.aria-label]="
      T.F.TASK.MULTI_SELECT.SELECTED_COUNT | translate: { count: count() }
    "
  >
    <button
      (click)="clear()"
      [attr.aria-label]="T.F.TASK.MULTI_SELECT.CLEAR | translate"
      [matTooltip]="T.F.TASK.MULTI_SELECT.CLEAR | translate"
      mat-icon-button
    >
      <mat-icon>close</mat-icon>
    </button>
    <span
      class="count"
      aria-live="polite"
      >{{ T.F.TASK.MULTI_SELECT.SELECTED_COUNT | translate: { count: count() } }}</span
    >
    <span class="spacer"></span>
    <button
      #actionsTrigger="matMenuTrigger"
      [matMenuTriggerFor]="bulkMenu"
      (menuOpened)="onMenuOpened()"
      [disabled]="!count()"
      class="actions-btn"
      mat-flat-button
    >
      <mat-icon>more_horiz</mat-icon>
      {{ T.F.TASK.MULTI_SELECT.ACTIONS | translate }}
    </button>
  </div>
}

<!-- Hidden trigger for opening the same menu at a pointer / row position -->
<div
  #positionedTrigger="matMenuTrigger"
  [matMenuTriggerFor]="bulkMenu"
  (menuOpened)="onMenuOpened()"
  [style.left.px]="menuPosition().x"
  [style.top.px]="menuPosition().y"
  class="positioned-trigger"
></div>

<mat-menu
  #bulkMenu="matMenu"
  (closed)="onMenuClosed()"
>
  <div class="menu-title">
    {{ tasksTitleKey() | translate: { count: count() } }}
  </div>

  <button
    (click)="bulk.openScheduleDialog()"
    mat-menu-item
  >
    <span class="menuItemLeft">
      <mat-icon>today</mat-icon>
      {{ T.F.TASK.CMP.SCHEDULE | translate }}
    </span>
    <span class="key-i">{{ kb().taskSchedule }}</span>
  </button>
  @if (bulk.hasScheduled()) {
    <button
      (click)="bulk.unschedule()"
      mat-menu-item
    >
      <span class="menuItemLeft">
        <mat-icon>event_busy</mat-icon>
        {{ T.F.TASK.CMP.UNSCHEDULE_TASK | translate }}
      </span>
      <span class="key-i">{{ kb().taskUnschedule }}</span>
    </button>
  }
  <button
    (click)="bulk.addToToday()"
    mat-menu-item
  >
    <span class="menuItemLeft">
      <mat-icon>wb_sunny</mat-icon>
      {{ T.F.TASK.CMP.ADD_TO_MY_DAY | translate }}
    </span>
    <span class="key-i">{{ kb().taskScheduleToday }}</span>
  </button>
  <button
    (click)="bulk.openDeadlineDialog()"
    mat-menu-item
  >
    <span class="menuItemLeft">
      <mat-icon>flag</mat-icon>
      {{ T.F.TASK.ADDITIONAL_INFO.DEADLINE | translate }}
    </span>
    <span class="key-i">{{ kb().taskScheduleDeadline }}</span>
  </button>
  @if (bulk.hasDeadline()) {
    <button
      (click)="bulk.removeDeadline()"
      mat-menu-item
    >
      <span class="menuItemLeft">
        <mat-icon>flag</mat-icon>
        {{ T.F.TASK.CMP.REMOVE_DEADLINE | translate }}
      </span>
    </button>
  }

  <mat-divider></mat-divider>

  <button
    (click)="bulk.toggleDone()"
    mat-menu-item
  >
    <span class="menuItemLeft">
      @if (bulk.hasUndone()) {
        <mat-icon>check</mat-icon>
        {{ T.F.TASK.CMP.MARK_DONE | translate }}
      } @else {
        <mat-icon>undo</mat-icon>
        {{ T.F.TASK.CMP.MARK_UNDONE | translate }}
      }
    </span>
    <span class="key-i">{{ kb().taskToggleDone }}</span>
  </button>

  @if (isShowBacklogBtns() && bulk.hasParentTasks()) {
    <button
      (click)="bulk.moveToBacklog()"
      mat-menu-item
    >
      <span class="menuItemLeft">
        <mat-icon>move_down</mat-icon>
        {{ T.F.TASK.CMP.MOVE_TO_BACKLOG | translate }}
      </span>
      <span class="key-i">{{ kb().moveToBacklog }}</span>
    </button>
    <button
      (click)="bulk.moveToRegularList()"
      mat-menu-item
    >
      <span class="menuItemLeft">
        <mat-icon>move_up</mat-icon>
        {{ T.F.TASK.CMP.MOVE_TO_REGULAR | translate }}
      </span>
    </button>
  }

  @if (bulk.hasEstimatable()) {
    <button
      #estimateTrigger="matMenuTrigger"
      [menuTouchFix]="estimateTrigger"
      [matMenuTriggerFor]="estimateMenu"
      mat-menu-item
    >
      <span class="menuItemLeft">
        <mat-icon>hourglass_empty</mat-icon>
        {{ T.F.TASK.CMP.ESTIMATE | translate }}
      </span>
      <span class="key-i">{{ kb().taskOpenEstimationDialog }}</span>
    </button>
  }

  <button
    #tagTrigger="matMenuTrigger"
    [menuTouchFix]="tagTrigger"
    [matMenuTriggerFor]="tagMenu"
    mat-menu-item
  >
    <span class="menuItemLeft">
      <mat-icon>label</mat-icon>
      {{ T.F.TASK.CMP.TOGGLE_TAGS | translate }}
    </span>
    <span class="key-i">{{ kb().taskEditTags }}</span>
  </button>

  @if (bulk.hasParentTasks() && moveToProjectList().length) {
    <button
      #projectTrigger="matMenuTrigger"
      [menuTouchFix]="projectTrigger"
      [matMenuTriggerFor]="projectMenu"
      mat-menu-item
    >
      <span class="menuItemLeft">
        <mat-icon>forward</mat-icon>
        {{ T.F.TASK.CMP.MOVE_TO_OTHER_PROJECT | translate }}
      </span>
      <span class="key-i">{{ kb().taskMoveToProject }}</span>
    </button>
  }

  <mat-divider></mat-divider>

  <button
    (click)="bulk.deleteSelected()"
    class="color-warn"
    mat-menu-item
  >
    <span class="menuItemLeft">
      <mat-icon class="color-warn-i">delete_forever</mat-icon>
      {{ T.F.TASK.CMP.DELETE | translate }}
    </span>
    <span class="key-i">{{ kb().taskDelete }}</span>
  </button>
</mat-menu>

<mat-menu #estimateMenu="matMenu">
  <ng-template matMenuContent>
    @for (option of ESTIMATE_OPTIONS; track option.value) {
      <button
        (click)="bulk.setEstimate(option.ms)"
        menuTouchFix
        mat-menu-item
      >
        {{ option.label }}
      </button>
    }
    <mat-divider></mat-divider>
    <button
      (click)="bulk.setEstimate(0)"
      menuTouchFix
      mat-menu-item
    >
      <mat-icon>clear</mat-icon>
      {{ T.F.TASK.CMP.CLEAR_ESTIMATE | translate }}
    </button>
  </ng-template>
</mat-menu>

<mat-menu #tagMenu="matMenu">
  <ng-template matMenuContent>
    <div (click)="$event.stopPropagation()">
      @for (tag of toggleTagList(); track tag.id) {
        <button
          (click)="bulk.toggleTag(tag.id)"
          menuTouchFix
          mat-menu-item
        >
          <select-option-row
            [title]="tag.title"
            [icon]="tag.icon"
            defaultIcon="label"
            [color]="tag.color || tag.theme?.primary"
            [isSelected]="bulk.isTagOnAllSelected(tag.id)"
            [showCheckbox]="true"
            [folderPath]="tagFolderMap().get(tag.id)"
          ></select-option-row>
        </button>
      }
    </div>
  </ng-template>
</mat-menu>

<mat-menu #projectMenu="matMenu">
  <ng-template matMenuContent>
    @if (moveToProjectList(); as list) {
      @for (project of list; track project.id) {
        <button
          (click)="bulk.moveToProject(project.id)"
          menuTouchFix
          mat-menu-item
        >
          <select-option-row
            [title]="project.title"
            [icon]="project.icon"
            [defaultIcon]="DEFAULT_PROJECT_ICON"
            [color]="project.theme?.primary"
            [folderPath]="projectFolderMap().get(project.id)"
          ></select-option-row>
        </button>
      }
    }
  </ng-template>
</mat-menu>
